<template>
    <v-list two-line v-if="surveys && surveys.length > 0">
        <v-list-item v-for="survey in surveys" :key="survey.id" :to="{ name: 'survey', params: { id: survey.id } }">
            <v-list-item-avatar>
                <v-icon size="24">
                    {{ icons.mdiPoll }}
                </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title class="mb-1 text-lg">
                    {{ survey.title }}</v-list-item-title>
                <v-list-item-subtitle>
                    {{
                        $t("Vastausaika päättyy") + " " + getDateTime(survey.expire_date)
                    }}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
import { getDateTime } from "@/@core/utils/datetime_helpers";
import { mdiPoll } from "@mdi/js";

export default {
    props: ["surveys"],
    setup() {
        return {
            getDateTime,
            icons: {
                mdiPoll,
            },
        };
    },
};
</script>

<style></style>
